<template>
  <GridContainer v-bind="AppLayout">
    <slot />
  </GridContainer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import GridContainer from './GridContainer.vue'
import { GridContainerProps } from './GridContainer.vue'

export default defineComponent({
  components: {
    GridContainer
  },
  setup() {
    const AppLayout: GridContainerProps = {
      rows: ['70px', '1fr'],
      cols: ['100px', 'auto', '8px', '1fr', '100px'],
      areas: [
        ['header', 'header', 'header', 'header', 'header'],
        ['sidemenuleft', 'problem', 'scrollbar', 'editor', 'sidemenuright']
      ]
    }

    return {
      AppLayout
    }
  }
})
</script>
